import { configureStore } from "@reduxjs/toolkit";
import articleSeries from "../reducers/articleSeriesReducer";

export const store = configureStore({
  reducer: {
    articleSeries: articleSeries,
  },
});
